<template>
  <div class="header-main">
    <div class="left-header-content">
      <!-- <Breadcrumb class="breadcrumb-container" /> -->
      <img class="logo_img" src="@/assets/images/login/logo.png" />
    </div>
    <div class="middle-header-content"> {{ systemName }} </div>
    <div class="right-header-content">
      <el-dropdown @command="handleCommand">
        <span class="el-dropdown-link">
          <img class="user-photo" src="https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png" alt="" />
          <span class="user-name">{{ nickName }}</span>
        </span>
        <template #dropdown>
          <el-dropdown-menu>
            <!-- <el-dropdown-item command="userCenter">个人中心</el-dropdown-item> -->
            <el-dropdown-item divided command="layout">退出</el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
    </div>

    <!-- 个人信息弹窗 -->
    <el-dialog title="个人信息" :model-value="dialogVisibleInfo" @close="handleClose">
      <el-form :model="userInfo" ref="userInfoForm">
        <el-form-item label="用户名" :label-width="formLabelWidth">
          <el-input v-model="userInfo.userName" autocomplete="off" :disabled="true" />
        </el-form-item>
        <el-form-item label="昵称" :label-width="formLabelWidth">
          <el-input v-model="userInfo.nickName" autocomplete="off" />
        </el-form-item>
        <el-form-item label="租户名称" :label-width="formLabelWidth">
          <el-input v-model="userInfo.tenantName" autocomplete="off" :disabled="true" />
        </el-form-item>
        <el-form-item label="电话" :label-width="formLabelWidth">
          <el-input v-model="userInfo.phone" autocomplete="off" />
        </el-form-item>
        <el-form-item label="邮件地址" :label-width="formLabelWidth">
          <el-input v-model="userInfo.email" autocomplete="off" />
        </el-form-item>
        <el-form-item label="密码" :label-width="formLabelWidth">
          <el-input v-model="userInfo.passWord" autocomplete="off" placeholder="******" show-password />
        </el-form-item>
      </el-form>

      <template #footer>
        <el-button @click="dialogVisibleInfo = false">取 消</el-button>
        <el-button type="primary" @click="onUpdateUserInfo">确 定</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { ElMessageBox, ElMessage } from 'element-plus';
import { SYSTEM_NAME } from "@/constant/Const";
import { Menu } from '@element-plus/icons-vue';
import Breadcrumb from '../Breadcrumb/index.vue';
import { getUserInfo, updateUser } from '@/api/auth/user/index';
import { logout } from '@/api/auth/login/index';

const systemName = SYSTEM_NAME;
// refs
const dialogVisibleInfo = ref(false);
const formLabelWidth = '120px';
const userInfo = ref({});
const nickName = ref('')
nickName.value = JSON.parse(sessionStorage.getItem('userInfo')).nickName
// router & store
const router = useRouter();
const store = useStore();
const userInfoForm = ref(null);

// 方法
function handleLanguage(lang) {
  if (lang !== localStorage.getItem('language')) {
    localStorage.setItem('language', lang);
    if (window.$translate) {
      window.$translate.changeLanguage(lang);
      window.$translate.execute();
    }
  }
}

function handleMenu() {
  store.commit('collapseMenu');
}

function handleCommand(command) {
  if (command === 'layout') {
    ElMessageBox.confirm('此操作将注销登录, 是否继续?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    })
      .then(() => {
        logout().then(() => {
          sessionStorage.clear();
          router.replace('/login');
        });
      })
      .catch(() => {
        ElMessage({ type: 'info', message: '已取消操作' });
      });
  } else if (command === 'userCenter') {
    dialogVisibleInfo.value = true;
    getUserInfo().then((resp) => {
      userInfo.value = resp.data;
    });
  }
}

function handleClose() {
  // 关闭弹窗
  dialogVisibleInfo.value = false;
}

function onUpdateUserInfo() {
  updateUser(userInfo.value).then(() => {
    dialogVisibleInfo.value = false;
  });
}
</script>

<style scoped lang="less">
.header-main {
  padding: 0 20px;
  background-color: #0981f1;
  height: 60px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .left-header-content {
    display: flex;
    align-items: center;

    .logo_img {
      width: 120px;
      height: auto;
    }
  }

  .middle-header-content {
    font-weight: bold;
    font-size: 24px;
    color: #FFFFFF;
  }

  .breadcrumb-container {
    margin-left: 10px;
  }

  .right-header-content {
    display: flex;
    align-items: center;

    .header-language {
      margin-right: 10px;
      cursor: pointer;

      .lang-img {
        width: 40px;
        height: 40px;
        border-radius: 50%;
      }
    }

    .el-dropdown-link {
      display: flex;
      align-items: center;
    }

    .user-photo {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      cursor: pointer;
    }

    .user-name {
      margin-left: 8px;
      color: #fff;
      cursor: pointer;
      font-weight: bold;
      font-size: 16px;
    }
  }
}
</style>
